// Build-time flag for the static (backendless) Netlify build. Set REACT_APP_STATIC=1
// in the Netlify build command (netlify.toml). When true:
//   - audio is served from the bundled /audio/... (relative), not the backend
//   - vocab/SRS + reading position live in versioned localStorage (see staticStore.js)
//   - glosses come from the bundled dictionary; editing (timings + glosses) is OFF
//   - the login gate is bypassed (single anonymous local user)
// When false (local dev), the app behaves exactly as before (backend-backed).
export const STATIC = process.env.REACT_APP_STATIC === '1';
